var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "colgroup",
    _vm._g(_vm._b({}, "colgroup", _vm.attributes, false), _vm.events),
    _vm._l(_vm.cols, function(col) {
      return _c("grid-col", _vm._b({ key: col.key }, "grid-col", col, false))
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5109d573", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5109d573","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/renderer/grid-colgroup.vue
// module id = 25
// module chunks = 0